import { TListingRoadblockChecklistItemType, TListingRoadblockType } from "../codecs/form/ListingRoadblockForm";
import { shListingRoadblockConfigs } from "./shListingRoadblockConfigs";

export type TListingRoadblockChecklistItemOption = {
    type: TListingRoadblockChecklistItemType;
    label: string;
};

const optionsByType: Map<TListingRoadblockType, Array<TListingRoadblockChecklistItemOption>> = (() => {
    const map = new Map<TListingRoadblockType, Array<TListingRoadblockChecklistItemOption>>();
    shListingRoadblockConfigs.forEach((roadblock) => {
        const seen = new Set<TListingRoadblockChecklistItemType>();
        const options = roadblock.checklist.reduce<Array<TListingRoadblockChecklistItemOption>>((acc, item) => {
            if (!seen.has(item.type)) {
                seen.add(item.type);
                acc.push({ type: item.type, label: item.is_resolved_by_short_description });
            }
            return acc;
        }, []);
        map.set(roadblock.type, options);
    });
    return map;
})();

export const getListingRoadblockChecklistItemOptions = (
    roadblockType: TListingRoadblockType,
): Array<TListingRoadblockChecklistItemOption> => optionsByType.get(roadblockType) ?? [];

export const listingRoadblockTypeOptions: Array<TListingRoadblockType> =
    shListingRoadblockConfigs.map((roadblock) => roadblock.type);
